import { useEffect } from 'react';
import { getQueryParams, stringifyQueryParams } from 'core/common/utils/getQueryParams';
import { isUtmTag } from 'core/user/entities';
import { UtmTagsService } from 'core/user/services';
import { AppEnvironment } from '../services';
import { useRouter } from './useRouter';

const PRESERVED_QUERY_PARAMS = ['order_id', 'user_id', 'email'];

export const useClearQueryParams = (
  utmTagsService: UtmTagsService,
  appEnvironment: AppEnvironment,
) => {
  const router = useRouter();

  const isTestingEnv = appEnvironment.isTestingEnv();

  useEffect(() => {
    if (!router.isReady || isTestingEnv) return;

    const queryParams = getQueryParams();

    if (!Object.keys(queryParams).length) return;

    const persistedTags = utmTagsService.getUtmTags();

    const areUtmTagsPersisted = Object.keys(queryParams)
      .filter(isUtmTag)
      .every((tag) => tag in persistedTags);

    if (!areUtmTagsPersisted) return;

    const [pathWithoutQuery] = router.asPath.split('?');

    const preservedParams = Object.fromEntries(
      PRESERVED_QUERY_PARAMS.filter((key) => queryParams[key] !== undefined).map((key) => [
        key,
        queryParams[key],
      ]),
    );

    const preservedQuery = stringifyQueryParams(preservedParams);

    const nextPath = preservedQuery ? `${pathWithoutQuery}?${preservedQuery}` : pathWithoutQuery;

    router.replace(nextPath, undefined, { shallow: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.isReady, isTestingEnv]);
};
